import React, { useState } from 'react'
import { Link } from 'react-router-dom';

const FeaturedCategoryForPunchout = ({ containerObject }) => {
    const [showState, setShowState] = useState({})

    return (
        <div className='row px-4 py-4 punchout-featured-category'>
            {containerObject && containerObject.results.map((item, index) => {
                return (
                    <div className='col-4'>
                        <div className='d-flex'>
                            <div className='featured-cat-img'>
                                <Link to={item && item.categoryUrl ? item.categoryUrl : ""}><img className='' src={item && item.categoryThumbnailImageUrl ? item.categoryThumbnailImageUrl : ""} /></Link>
                            </div>
                            <div className='featured-cat-sec'>
                                <Link className='punchout-cat-name' to={item && item.categoryUrl ? item.categoryUrl : ""} dangerouslySetInnerHTML={{__html: item && item["category.categoryName"] ? item["category.categoryName"] : ""}}></Link>
                                <p dangerouslySetInnerHTML={{__html: item && item["category.categoryDescription"] ? item["category.categoryDescription"] : ""}}></p>
                                <ul className='child-cat-name'>
                                    {item && item.childCatDetailsMap ? item.childCatDetailsMap.map((oneCat,idx) => {
                                        return (
                                            <li className={`row ${idx > 2 ? "d-none" : ""}`}><Link to={oneCat && oneCat.childCatUrl ? oneCat.childCatUrl : ""} dangerouslySetInnerHTML={{__html:oneCat && oneCat.childCatName ? oneCat.childCatName :""}}></Link></li>
                                        )
                                    }) : ""}
                                   <li class="link-light-black">
                                         <Link to={item && item.categoryUrl ? item.categoryUrl : ""}>View All »</Link>
                                    </li>
                                </ul>

                            </div>
                        </div>
                    </div>)
            })}
        </div>
    )
}

export default FeaturedCategoryForPunchout